import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Profile } from './profile';

@Injectable({
    providedIn: 'root'
})
export class EcorrGuardService {
    constructor(private httpClient: HttpClient,
        private router: Router,
    ) { }

    getProfileByUserAccountId(userAccountId: number): Observable<Profile> {
        let profilesUrl: string = null;
        if (ecorEnv.cpassEnabled) {
            profilesUrl = ecorEnv.apiEndpoint + '/secure/sso/profile';
        } else {
            if (!userAccountId || userAccountId <= 0) {
                this.router.navigate(['/portal']);
            } else {
                profilesUrl = ecorEnv.apiEndpoint + '/secure/profiles/' + userAccountId;
            }
        }

        return this.httpClient.get<Profile>(profilesUrl);
    }

}
